export const formatCurrency = (amount: number = 0): string =>
  `$${amount.toLocaleString("en-US")}`;

export const parseRate = (rateString: string): number => {
  const match = rateString?.match(/(\d+(\.\d+)?)%/);
  return match ? parseFloat(match[1]) : 0;
};
